var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSparkleColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.4601 14.9572C31.7909 14.9572 31.9564 14.7642 32.0391 14.461C32.8936 9.85718 32.8385 9.74696 37.6353 8.83716C37.966 8.78211 38.159 8.5891 38.159 8.25823C38.159 7.92748 37.966 7.73446 37.6353 7.67929C32.8661 6.71456 33.0039 6.60423 32.0391 2.05557C31.9564 1.75234 31.7909 1.55933 31.4601 1.55933C31.1293 1.55933 30.9639 1.75234 30.8812 2.05557C29.9163 6.60423 30.0817 6.71456 25.285 7.67929C24.9818 7.73446 24.7612 7.92748 24.7612 8.25823C24.7612 8.5891 24.9818 8.78211 25.285 8.83716C30.0817 9.80213 30.0266 9.85718 30.8812 14.461C30.9639 14.7642 31.1293 14.9572 31.4601 14.9572ZM18.1175 33.9237C18.6413 33.9237 18.9996 33.5929 19.0547 33.0967C20.0472 25.7361 20.2953 25.7361 27.904 24.2751C28.4002 24.1923 28.7585 23.8616 28.7585 23.3378C28.7585 22.8415 28.4002 22.4831 27.904 22.4005C20.2953 21.3529 20.0195 21.1047 19.0547 13.6064C18.9996 13.1102 18.6413 12.7518 18.1175 12.7518C17.6212 12.7518 17.2628 13.1102 17.2077 13.634C16.298 21.0221 15.912 20.9945 8.35854 22.4005C7.8623 22.5108 7.50391 22.8415 7.50391 23.3378C7.50391 23.8891 7.8623 24.1923 8.46876 24.2751C15.9671 25.488 16.298 25.681 17.2077 33.0416C17.2628 33.5929 17.6212 33.9237 18.1175 33.9237ZM36.8083 64.441C37.525 64.441 38.0488 63.9172 38.1865 63.1729C40.1439 48.0658 42.2666 45.7777 57.2082 44.1236C57.9801 44.0409 58.5039 43.462 58.5039 42.7453C58.5039 42.0286 57.9801 41.4771 57.2082 41.3669C42.2666 39.7128 40.1439 37.4247 38.1865 22.3178C38.0488 21.5735 37.525 21.0772 36.8083 21.0772C36.0915 21.0772 35.5677 21.5735 35.4575 22.3178C33.5002 37.4247 31.3499 39.7128 16.4357 41.3669C15.6364 41.4771 15.1126 42.0286 15.1126 42.7453C15.1126 43.462 15.6364 44.0409 16.4357 44.1236C31.3223 46.081 33.3898 48.0935 35.4575 63.1729C35.5677 63.9172 36.0915 64.441 36.8083 64.441Z",
    fill: "url(#paint0_linear_454_30847)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_454_30847",
    x1: 20.5247,
    y1: 3.89157,
    x2: 49.9657,
    y2: 59.2806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89D0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.278846,
    stopColor: "#6E64FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616404,
    stopColor: "#AD45F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.836538,
    stopColor: "#FF7DE1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkleColor);
export default __webpack_public_path__ + "static/media/sparkle-color.f2a59a6225ba8dc715da91c79aa1d6ae.svg";
export { ForwardRef as ReactComponent };